export const styles = {
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
  tooltip: {
    backgroundColor: '#fff',
    boxShadow: '0px 5px 10px 0px #00000033',
    color: '#000000DE',
    fontSize: 16,
    padding: '8px 16px',
    borderRadius: '8px',
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    lineHeight: '24px',
    width: '500px !important',
    maxWidth: '500px !important',
    '& .MuiTooltip-arrow': {
      color: '#fff',
    },
  },
  popper: {
    zIndex: 9999,
    width: '500px !important',
    maxWidth: '500px !important',
  },
}
